import React from 'react';
import styles from './LearnArticlesContent.module.scss';
import { Card } from './Card';

type ArticleImage = {
  url?: string;
};

type ArticlePreview = {
  title: string;
  url: string;
  image?: ArticleImage;
  category: string;
  date: string;
  timeToRead: number;
  author: string;
  authorPicture?: ArticleImage;
};

export const LearnArticlesContent = ({ data }: { data: any }) => (
  <>
    <h1 className="visually-hidden">Learn everything about Home Loans</h1>
    <div className={styles['grid-container']}>
      <div className={styles.container}>
        {data.cachedData?.map(
          ({ title, url, image, category, date, timeToRead, author, authorPicture }: ArticlePreview, index: number) => (
            <React.Fragment key={title}>
              <Card
                key={title}
                to={`/learn${url}`}
                isHero={index === 0}
                imageSrc={image?.url}
                heading={title}
                category={category}
                date={date}
                timeToRead={timeToRead}
                authorName={author}
                isTileWithImage={index > 0}
                authorImageSrc={authorPicture?.url}
              />
            </React.Fragment>
          ),
        )}
      </div>
    </div>
  </>
);
